import { Category } from '@/types/Category';
import { Template } from '@/types/Template';

export function getCategoriesWithTemplates(categories: Category[], templates: Template[]) {
    return categories.filter((category) => {
        return templates.find((template) => {
            return template.categories.find((id) => id === category.id);
        });
    });
}
